export const meta: BlockMeta = {
  title: "Spacer",
  description: "A content spacer",
  category: "layouts",
  icon: "book-alt",
  keywords: ["post"],
  tags: ["root", "content"],
}

import { Spacer } from "@components/atoms/Spacer"
import { defineBlock } from "eddev/blocks"

export default defineBlock("content/spacer", (props) => {
  return <Spacer size={props.size || "4"} />
})
